import { httpPost } from "../http"

interface GetPartnerCodeData {
  partner_id: number
  partner_secret: string
  user: User
  partner_name: string
}

interface User {
  phone_no: string
  fullname: string
  user_id: string
}

export async function getPartnerCode(data: GetPartnerCodeData): Promise<{
  code: string
}> {
  const resp = await httpPost(
    `partner/${data.partner_name}/authorize`,
    data,
    undefined,
    `api/v1/be-web-gateway/partner/${data.partner_name}/authorize`
  )

  return resp?.data
}

export async function getPartnerAccessTokenFromCode(
  code: string,
  verifier?: string
): Promise<{
  access_token: string
  unique_device_id: string
}> {
  const resp = await httpPost(
    `public/v1/auth/access-token`,
    {
      code,
      code_verifier: verifier,
    },
    undefined,
    `api/v1/be-web-gateway/public/v1/auth/access-token`
  )

  return resp?.data
}
